<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol
                    ><h1 class="page__title text-center">
                        {{ $t(titlePage) }}
                    </h1></CCol
                >
                <CCol>
                    <div class="btn-wrapper btn-wrapper__end-center">
                        <ButtonCreate
                            :title="$t('add_new_provider')"
                            @click="
                                $router.push({
                                    name: 'add_provider',
                                })
                            "
                        >
                            {{ $t("create_provider") }}
                        </ButtonCreate>
                    </div>
                </CCol>
            </CRow>
            <!-- Title page -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.provider_group.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'provider_group',
                        })
                    "
                >
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.provider_group.allFields
                                        "
                                        :activeFields.sync="
                                            tables.provider_group.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CDataTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.provider_group.items"
                                    :fields="
                                        traslateLabels(
                                            tables.provider_group.fields
                                        )
                                    "
                                    :items-per-page="tables.provider_group.rows"
                                    :loading="tables.provider_group.loading"
                                    :columnFilterValue.sync="
                                        tables.provider_group.columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.provider_group.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    v-bind="tables.provider_group"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables.provider_group
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        tag="div"
                                                        class="text-cent\er"
                                                        @click="
                                                            $router.push({
                                                                name: 'edit_provider',
                                                                query: {
                                                                    uuid: tables
                                                                        .provider_group
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("edit")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        tag="div"
                                                        @click="
                                                            deleteItem(
                                                                tables
                                                                    .provider_group
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        <strong>{{
                                                            $t("delete")
                                                        }}</strong>
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <td class="py-2">
                                            <CInputRadio
                                                name="_selected"
                                                :checked="
                                                    item ===
                                                    tables.provider_group
                                                        .itemSelected
                                                "
                                                @update:checked="
                                                    selectItemTable(
                                                        'provider_group',
                                                        item
                                                    )
                                                "
                                            />
                                        </td>
                                    </template>

                                    <template #webservices="{ item }">
                                        <td v-if="item.webservices">
                                            {{ item.webservices }}
                                        </td>
                                        <td v-else>-</td>
                                    </template>

                                    <template #created_at="{ item }">
                                        <td>
                                            <span>{{
                                                item.created_at.split(" ")[0]
                                            }}</span>
                                        </td>
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/providers.api/groups"
                                                :table="tables.provider_group"
                                            />
                                        </div>
                                    </template>
                                </CDataTable>
                            </CCardBody>
                            <CCardFooter
                                v-show="tables.provider_group.items.length > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.provider_group.page"
                                        :pages="
                                            tables.provider_group.total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.provider_group.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'provider_group',
                    })
                "
            >
                <template #title> Create you first Provider </template>
                <template #description>
                    {{ $t("first_item.provider.description") }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('add_new_provider')"
                        @click="
                            $router.push({
                                name: 'add_provider',
                            })
                        "
                    >
                        {{ $t("create_provider") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'provider_group',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('provider_group'), updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean Filter") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import NoItemsContainer from "~/components/NoItemsContainer";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import TableSettings from "£lement/TableSettings";
/** Icons */
import { eraser } from "~/assets/icons/js/eraser";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilTrash,
    cilGroup,
    cilArrowThickFromRight,
} from "@coreui/icons";

export default {
    name: "ProvidersMainPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        ButtonCreate,
        FilterFields,
        ButtonExport,
        NoItemsContainer,
        TableSettings,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilTrash,
        cilGroup,
        cilArrowThickFromRight,
        eraser,
    },
    watch: {
        "tables.provider_group.loading": {
            handler(newValue) {
                this.updatePageLoading(newValue);
            },
            deep: true,
        },
    },
    data() {
        return {
            tables: {
                provider_group: {
                    fields: [
                        {
                            key: "_selected",
                            label: "",
                            fixed: true,
                            sortable: false,
                            active: true,
                            filter: false,
                            _filter: false,
                        },
                        {
                            key: "id",
                            label: "#",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "name",
                            label: "name",
                            sorter: false,
                            filter: true,
                            _filter: true,
                            active: true,
                        },
                        {
                            key: "country_id",
                            label: "country",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "created_at",
                            label: "creation_date",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                        {
                            key: "updated_at",
                            label: "updated_at",
                            sorter: false,
                            filter: false,
                            _filter: false,
                            active: true,
                        },
                    ],
                    allFields: [],
                    items: [],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 1,
                    loading: true,
                    hover: true,
                    pagination: true,
                    sorter: {
                        external: true,
                        resetable: true,
                    },
                    sorterValue: {},
                    size: "sm",
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                    itemSelected: null,
                },
            },
        };
    },
    methods: {
        updatePagination(newValue) {
            this.tables.provider_group.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "provider_group",
                url: "/providers.api/groups",
                adapterFilters: (filters) => {
                    delete filters.where.created_at;
                    return filters;
                },
            });

            this.loadLanguageInTable({
                tableName: "provider_group",
                fielLanguageName: "language_id",
            });
            this.loadCountryInTable({
                tableName: "provider_group",
                fielCountryName: "country_id",
            });

            this.tables.provider_group.itemSelected = null;

            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },
        async deleteItem(item) {
            try {
                await this.deleteData({
                    url: `/providers.api/groups/${item.uuid}/delete`,
                });

                this.updateData();
            } catch (error) {
                return;
            }
        },
    },
    mounted() {
        this.updateData();
    },
    created() {
        this.loadLanguages();
        this.loadCountries();
    },
};
</script>

<style lang="scss">
.btn-create-wrapper {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
</style>